export const MaxLengths = {
	SURNAME: 100,
	NAME: 50,
	BIRTH_NUMBER: 10,
	BUSINESS_NAME: 128,
	LOGIN: 75,
	POLICY_NO: 10,
	PROPOSAL_NO: 20,
	ZIP_CODE: 10,
	STREET_NO: 10,
	STREET: 100,
	DATE: 10,
	PERSON_IN: 10,
	NOTE: 2000,
	NOTE_BIG: 4000,
	MUNICIPALITY: 55,
	TAX_NUMBER: 8,
	CAR_REG_NO: 10,
	POLICY_FRAMEWORK_NO: 22,
	DAY_MONTH_DATE: 5,
	YEAR_DATE: 4,
	SELLER_IN: 9,
	BUSINESS_CASE_NO: 16,
	EMAIL: 64,
	TITLE: 10,
	PHONE: 14,
	ADDITIONAL_INFO: 50,
	DOCUMENT_ID: 19,
	FILE_AMOUNT: 10,
	CLAIM_NO: 20,
	FILE_NAME: 50,
	PERCENTAGE: 3,
	PRODUCTION_PLAN: 10,
	EXPECTED_VALUE: 20,
	CAMPAIGN_TEMPLATE_NAME: 70,
	POLICY_AGENT: 80,
	PRODUCT: 50,
	ID: 22,
	QUEUE_GROUP_CD: 75,
};
